function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#36f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,15L0,25h30l-15-10Z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,14.25v1.5l30-1.5v1.5L0,14.25Z",
    style: {
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 5 0 6.25 15 15 1.25 5 0 5",
    style: {
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.75 5 15 15 30 6.25 30 5 28.75 5",
    style: {
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,15l-.75-10h1.5l-.75,10Z",
    style: {
      fill: "#ff0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRe);
export default __webpack_public_path__ + "static/media/RE.d79b61a75e55f6acbb626fb0fdb16208.svg";
export { ForwardRef as ReactComponent };